export default __webpack_public_path__ + "static/N0137-5230357400e9a11f6f3934bf54c0bee0.png";